import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './components/ThemeContext'
import Background from './components/Background'
import reportWebVitals from './reportWebVitals';
// import ChunkErrorBoundary from './components/ChunkErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    //<React.StrictMode>
    // <ChunkErrorBoundary>
    <ThemeProvider>
        {/*<Background>*/}
        <App />
        {/*</Background>*/}
    </ThemeProvider>
    // </ChunkErrorBoundary>
    //</React.StrictMode>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
